(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('VintageSummaryReportController', VintageSummaryReportController);

	VintageSummaryReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function VintageSummaryReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			types: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		self.title = $state.current.data.title;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine Types',
							'Wines',
							'% Wines in Cellar',
							'Bottles',
							'% Bottles in Cellar',
							'Producers',
							'Varietals',
							'Countries',
							'Red',
							'White',
							'Sparkling',
							'Dessert',
							'Fortified',
							'Rose',
							'Other Types'
						];

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						var totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);
						
						var winesGrouped = lodash.groupBy(self.wines, function(w) {
							return (w.vintage) ? w.vintage : '<em>Unknown</em>';
						});

						// initialize totals
						var totals = {
							wines:  0,
							bottles: 0,
						};

						var categoryGrandTotals = {
							red: 0,
							white: 0,
							sparkling: 0,
							dessert: 0,
							fortified: 0,
							rose: 0,
							other: 0
						};

						lodash.forEach(winesGrouped, function(wines, type) {
							var totalTypeCount = wines.length;

							// add wines to grand total
							totals.wines += totalTypeCount;

							// count bottles, start at 0
							var totalTypeBottles = lodash.reduce(wines, function(total, wine) {
								return total + lodash.parseInt(wine.cellar.qty);
							}, 0);

							// add bottles to grand total
							totals.bottles += totalTypeBottles;

							// get total by category
							var groupedCategoryName = lodash.groupBy(wines, function(wine) {
								return lodash.get(wine, 'category.name', 'other').toLowerCase();
							});

							var categoryTotal = {};
							categoryTotal.red = (groupedCategoryName['red']) ? groupedCategoryName['red'].length : '0';
							categoryTotal.white = (groupedCategoryName['white']) ? groupedCategoryName['white'].length : '0';
							categoryTotal.sparkling = (groupedCategoryName['sparkling']) ? groupedCategoryName['sparkling'].length : '0';
							categoryTotal.dessert = (groupedCategoryName['dessert']) ? groupedCategoryName['dessert'].length : '0';
							categoryTotal.fortified = (groupedCategoryName['fortified (non-dessert)']) ? groupedCategoryName['fortified (non-dessert)'].length : '0';
							categoryTotal.rose = (groupedCategoryName['rose']) ? groupedCategoryName['rose'].length : '0';
							categoryTotal.other = (groupedCategoryName['other']) ? groupedCategoryName['other'].length : '0';

							lodash.forEach(categoryGrandTotals, function(val, key) {
								categoryGrandTotals[key] += parseInt(categoryTotal[key]);
							});

							var producers = lodash.unique(lodash.pluck(wines, 'producer.name'));
							var varietals = lodash.unique(lodash.pluck(wines, 'varietal.name'));
							var countries = lodash.unique(lodash.pluck(wines, 'region.country'));

							var summary = {
								"Wines": totalTypeCount,
								"% Wines in Cellar": $window.numeral(totalTypeCount / totalWines).format('0.00%'),
								"Producers": producers.length,
								"Varietals": varietals.length,
								"Countries": countries.length
							};

							// put bottles at the end b/c everything else is based on wines (having bottles between
							// wines and bodies seemed confusing)
							summary.Bottles = totalTypeBottles;
							summary["% Bottles in Cellar"] = $window.numeral(totalTypeBottles / totalBottles).format('0.00%');

							var tableSummary = [
								summary['Wines'],
								summary['% Wines in Cellar'],
								summary['Bottles'],
								summary['% Bottles in Cellar'],
								summary['Producers'],
								summary['Varietals'],
								summary['Countries'],
								// Red
								categoryTotal.red,
								// White
								categoryTotal.white,
								// Sparkling
								categoryTotal.sparkling,
								// Dessert
								categoryTotal.dessert,
								// Fortified
								categoryTotal.fortified,
								// Rose
								categoryTotal.rose,
								// Other Types
								categoryTotal.other
							];

							self.report.types.push({ type: type, summary: tableSummary });

						});

						// sort by type name
						self.report.types = lodash.sortBy(self.report.types, function(type) {
							return type.type;
						});

						self.report.totals = [
							// 'Wine Types',
							'Totals',
							// 'Wines',
							totals.wines,
							// '% Wines in Cellar',
							null,
							// 'Bottles',
							totalBottles,
							// '% Bottles in Cellar'
							null,
							// 'Producers',
							null,
							// 'Varietals',
							null,
							// 'Countries',
							null,
							// Category Totals
							categoryGrandTotals.red,
							categoryGrandTotals.white,
							categoryGrandTotals.sparkling,
							categoryGrandTotals.dessert,
							categoryGrandTotals.fortified,
							categoryGrandTotals.rose,
							categoryGrandTotals.other
						];

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function print(){
			return $window.print();
		}
	}

})();
